/**
 * Normalizes each ancillary `status` to upper case for downstream
 * (boarding pass / check-in) requests. The Passenger model stores the
 * status in lower case for internal enum matching; printing consumers
 * expect upper case. Returns a new array and never mutates the input.
 */
export function normalizeAncillariesStatus<T extends { status?: string }>(
  ancillaries: T[] | null | undefined
): T[] {
  return (
    ancillaries?.map((ancillary) => ({
      ...ancillary,
      status: ancillary.status?.toUpperCase(),
    })) ?? []
  );
}
